// extracted by mini-css-extract-plugin
export default {"hero":"Hero_hero__zvVCj","head":"Hero_head__zLzUQ","img":"Hero_img__oWQHK"};